import Precision from "../../../../types/datePrecision";
import dateAtEvenSpanBeforeDate from "./dateAtEvenSpanBeforeDate";
import {
  calculateTimestampForDate,
  calculateWeekdayForTimestamp,
  createImmutableDate,
  getFirstMonthOfYear
} from "./dateInternalCalculations";
import { timespanForPrecision } from "./timespanFunctions";

const dateWithComponents = (calendar, era, year, month, day, hour, minute, second, precision) => {
  if (precision === Precision.Auto) {
    if (second !== 0) {
      precision = Precision.Second;
    } else if (minute !== 0) {
      precision = Precision.Minute;
    } else if (hour !== 0) {
      precision = Precision.Hour;
    } else if (day !== 1) {
      precision = Precision.Day;
    } else if (month !== getFirstMonthOfYear(calendar, era, year)) {
      precision = Precision.Month;
    } else {
      precision = Precision.Year;
    }
  } else {
    if (precision < Precision.Month) {
      month = getFirstMonthOfYear(calendar, era, year);
    }
    if (precision < Precision.Week) {
      day = 1;
    }
    if (precision < Precision.Hour) {
      hour = 0;
    }
    if (precision < Precision.Minute) {
      minute = 0;
    }
    if (precision < Precision.Second) {
      second = 0;
    }
  }

  const timestamp = calculateTimestampForDate(calendar, era, year, month, day, hour, minute, second);
  const weekday = calculateWeekdayForTimestamp(calendar, timestamp);

  const date = createImmutableDate(era, year, month, day, hour, minute, second, timestamp, weekday, precision);

  if (precision === Precision.Week && weekday !== 0) {
    // Go to start of week.
    return dateAtEvenSpanBeforeDate(calendar, date, timespanForPrecision(Precision.Week));
  }
  return date;
};

export default dateWithComponents;
